export const COMPANY = {
  name: "Pro Solar Solutions",
  legalName: "Pro Solar Solutions, LLC",
  location: "West Chester, Ohio",
  tagline: "Solar System Repair Specialists",
  bbbUrl:
    "https://www.bbb.org/us/oh/west-chester/profile/solar-installation/pro-solar-solutions-llc-0292-90052686",
  bbbReviewsUrl:
    "https://www.bbb.org/us/oh/west-chester/profile/solar-installation/pro-solar-solutions-llc-0292-90052686/customer-reviews",
  socials: {
    facebook: "https://www.facebook.com/p/Pro-Solar-Solutions-LLC-61572602667935/",
    instagram: "https://www.instagram.com/prosolarsolutionsllc/",
    linkedin: "https://www.linkedin.com/company/pro-solar-solutions",
  },
};

export const SERVICE_AREAS = ["Dayton, OH", "Cincinnati, OH", "Columbus, OH", "Newport, KY", "Surrounding Areas"];

const CDN = "https://images.squarespace-cdn.com/content/v1/6640c1c6b5292a2677ff0662";

export const IMAGES = {
  hero: `${CDN}/8101b982-fcd2-46b5-b251-dff78516d071/1719134973219.jpg`,
  about: `${CDN}/31dd8532-a377-4471-a789-e2f4fbb422c6/unnamed+%287%29.jpg`,
  consulting: `${CDN}/8653832c-b4bc-4092-8e60-6fd2964cfd11/IMG_0462+%281%29.jpg`,
  residential: `${CDN}/30d307c7-2ac7-4933-b0eb-139b99071b20/IMG_5476.jpg`,
  training: `${CDN}/8f24ce25-21bd-4d22-aa9b-8db85936849e/1717726059877.jpg`,
  inspection: `${CDN}/8653832c-b4bc-4092-8e60-6fd2964cfd11/IMG_0462+%281%29.jpg`,
  operations: `${CDN}/64bb6194-3ca6-4f50-9e5d-d3ed04ce062d/EAC5D8C5-C06F-4AF2-817D-627FC6FB8B0F.JPG`,
  detach: `${CDN}/30d307c7-2ac7-4933-b0eb-139b99071b20/IMG_5476.jpg`,
  warranty: `${CDN}/50a043a2-60ea-446f-8d64-2e9dcee88c1b/IMG_3658.jpg`,
  expansion: `${CDN}/28fda12c-870d-4c2e-81c4-8588588b7a00/IMG_0458+%281%29.jpg`,
};

export const BUSINESS_SERVICES = [
  {
    slug: "technical-training",
    title: "PV Installation & Commissioning Technical Training",
    short: "Field-proven training that raises crew quality, safety and commissioning consistency.",
    description:
      "Pro Solar Solutions trains installation crews and service technicians on correct PV installation practices, commissioning procedures and manufacturer-specific requirements. Every program is built around your workforce, your workflows and the equipment you actually deploy.",
    points: ["Crew-level install standards", "Commissioning checklists & sign-off", "Manufacturer-specific procedures"],
    image: IMAGES.training,
  },
  {
    slug: "site-inspection",
    title: "Site Inspection Quality Control",
    short: "Independent inspections that catch defects before they become warranty claims.",
    description:
      "Third-party quality control on completed or in-progress installations. We document workmanship, code compliance and system performance with photo-backed reports, so projects close cleanly and callbacks stay off your books.",
    points: ["Pre- and post-install audits", "Photo-documented reports", "Code & manufacturer compliance"],
    image: IMAGES.inspection,
  },
  {
    slug: "operations-gap",
    title: "Operations Management Gap Filling",
    short: "Experienced O&M capacity when your team is stretched or a provider steps away.",
    description:
      "When an installer exits the market, a manufacturer needs a regional service partner, or your operations team is at capacity, Pro Solar Solutions steps in to manage service queues, fleet monitoring and field work — so end customers are never left without support.",
    points: ["Orphaned-system support", "Service queue management", "Fleet monitoring & dispatch"],
    image: IMAGES.operations,
  },
];

export const RESIDENTIAL_SERVICES = [
  {
    slug: "detach-reattach",
    title: "System Detach & Re-Attach",
    short: "Safe removal and reinstallation for roofing, siding or structural work.",
    description:
      "Replacing your roof? We detach the array, store every component securely, coordinate directly with your roofing contractor, then reinstall with fresh flashing and a complete commissioning test — documented from start to finish.",
    points: ["Coordination with roofing contractors", "Secure component storage", "Full re-commissioning"],
    image: IMAGES.detach,
  },
  {
    slug: "warranty-repair",
    title: "Warranty System Repair",
    short: "Certified diagnosis and repair across the major inverter, battery and panel brands.",
    description:
      "From failed inverters and microinverters to underperforming strings, we identify the root cause, handle the manufacturer warranty claim on your behalf and restore full production. As a certified service partner, we work directly with the brands on your roof.",
    points: ["Manufacturer warranty claims", "Inverter & battery replacement", "Performance restoration"],
    image: IMAGES.warranty,
  },
  {
    slug: "addition-expansion",
    title: "Addition & Expansion",
    short: "Add capacity, storage or EV charging to a system you already own.",
    description:
      "Energy needs change. We assess your existing system and design compatible panel additions, battery storage or EV-ready upgrades that integrate cleanly with the equipment already installed — no rip-and-replace.",
    points: ["Panel & inverter additions", "Battery storage integration", "EV charger readiness"],
    image: IMAGES.expansion,
  },
];

export const PARTNERS = [
  { name: "SolarEdge", logo: `${CDN}/c808a794-037b-433e-bccd-748b6b9dd089/Screenshot+2025-01-17+134345.png` },
  { name: "SunPower", logo: `${CDN}/b7a2e270-7f66-4cb9-8da0-7a0803c16c0d/Screenshot+2025-01-17+134504.png` },
  { name: "FranklinWH", logo: `${CDN}/90ed00bb-4122-4059-a5a9-d5907d3f9caf/Screenshot+2025-01-17+135212.png` },
  { name: "Generac", logo: `${CDN}/2dc274cf-032a-4815-ac7f-f18858fc2116/Screenshot+2025-01-17+134655.png` },
  { name: "Tesla", logo: `${CDN}/e21626e9-af33-452e-80dd-bae523332128/Screenshot+2025-01-17+135924.png` },
  { name: "Enphase", logo: `${CDN}/dcbde13e-5a03-4eb6-bb38-b8bbdeac1a9b/Screenshot+2025-01-17+134808.png` },
];

export const REVIEWS = [
  {
    name: "Michael P.",
    text: "Pro Solar Solutions is hands down incredible with professionalism, promptness, and going the extra mile to ensure I was taken care of. Hard to find incredible service providers like this.",
  },
  {
    name: "Terry P.",
    text: "Very professional with the review of our system and a straightforward proposal process. The work was of high quality and completed in a timely manner.",
  },
  {
    name: "Shirley A.",
    text: "This company was true to their word. They coordinated well with a roofing company.",
  },
];
